import React, { useState, useEffect } from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { format } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

const BRAZIL_TIMEZONE = 'America/Sao_Paulo';
const USA_TIMEZONE = 'America/New_York';

export const DualClock: React.FC = () => {
  const [currentTime, setCurrentTime] = useState(new Date());

  // Update clock every minute
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000);
    return () => clearInterval(timer);
  }, []);

  // Format time in a specific timezone
  const formatTimeInZone = (date: Date, timezone: string, use24Hour: boolean): string => {
    try {
      const zonedDate = toZonedTime(date, timezone);
      return format(zonedDate, use24Hour ? 'HH:mm' : 'h:mm a');
    } catch {
      return format(date, use24Hour ? 'HH:mm' : 'h:mm a');
    }
  };

  const brazilTime = formatTimeInZone(currentTime, BRAZIL_TIMEZONE, true);
  const usaTime = formatTimeInZone(currentTime, USA_TIMEZONE, false);

  return (
    <TooltipProvider>
      <div className="flex items-center gap-2 text-sm">
        {/* USA time - 12h format */}
        <Tooltip>
          <TooltipTrigger asChild>
            <div className="flex items-center gap-1.5 px-2 py-1 rounded-md bg-muted/50 hover:bg-muted transition-colors cursor-default">
              <span className="text-base">🇺🇸</span>
              <span className="font-mono text-xs font-medium text-foreground">{usaTime}</span>
            </div>
          </TooltipTrigger>
          <TooltipContent>
            <p className="text-xs">Orlando (EST)</p>
          </TooltipContent>
        </Tooltip>

        <span className="text-muted-foreground">|</span>

        {/* Brazil time - 24h format */}
        <Tooltip>
          <TooltipTrigger asChild>
            <div className="flex items-center gap-1.5 px-2 py-1 rounded-md bg-muted/50 hover:bg-muted transition-colors cursor-default">
              <span className="text-base">🇧🇷</span>
              <span className="font-mono text-xs font-medium text-foreground">{brazilTime}</span>
            </div>
          </TooltipTrigger>
          <TooltipContent>
            <p className="text-xs">São Paulo (BRT)</p>
          </TooltipContent>
        </Tooltip>
      </div>
    </TooltipProvider>
  );
};

export default DualClock;
